import { render, staticRenderFns } from "./submit-modal.vue?vue&type=template&id=4dc53702&scoped=true"
import script from "./submit-modal.vue?vue&type=script&lang=js"
export * from "./submit-modal.vue?vue&type=script&lang=js"
import style0 from "./submit-modal.vue?vue&type=style&index=0&id=4dc53702&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc53702",
  null
  
)

export default component.exports